/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import rootStyles from './_root.css';
import rebootStyles from './_reboot.css';
import typeStyles from './_type.css';
import imagesStyles from './_images.css';
import codeStyles from './_code.css';
import gridStyles from './_grid.css';
import tablesStyles from './_tables.css';
import formsStyles from './_forms.css';
import buttonsStyles from './_buttons.css';
import transitionsStyles from './_transitions.css';
import dropdownStyles from './_dropdown.css';
import buttonGroupStyles from './_button-group.css';
import inputStyles from './_input-group.css';
import customStyles from './_custom-forms.css';
import navStyles from './_nav.css';
import navbarStyles from './_navbar.css';
import cardStyles from './_card.css';
import breadcrumbStyles from './_breadcrumb.css';
import paginationStyles from './_pagination.css';
import badgeStyles from './_badge.css';
import jumbotronStyles from './_jumbotron.css';
import alertStyles from './_alert.css';
import progressStyles from './_progress.css';
import mediaStyles from './_media.css';
import listStyles from './_list-group.css';
import closeStyles from './_close.css';
import toastsStyles from './_toasts.css';
import modalStyles from './_modal.css';
import tooltipStyles from './_tooltip.css';
import popoverStyles from './_popover.css';
import carouselStyles from './_carousel.css';
import spinnersStyles from './_spinners.css';
import utilitiesStyles from './_utilities.css';
import printStyles from './_print.css';

const styles = [
  rootStyles,
  rebootStyles,
  typeStyles,
  imagesStyles,
  codeStyles,
  gridStyles,
  tablesStyles,
  formsStyles,
  buttonsStyles,
  transitionsStyles,
  dropdownStyles,
  buttonGroupStyles,
  inputStyles,
  customStyles,
  navStyles,
  navbarStyles,
  cardStyles,
  breadcrumbStyles,
  paginationStyles,
  badgeStyles,
  jumbotronStyles,
  alertStyles,
  progressStyles,
  mediaStyles,
  listStyles,
  closeStyles,
  toastsStyles,
  modalStyles,
  tooltipStyles,
  popoverStyles,
  carouselStyles,
  spinnersStyles,
  utilitiesStyles,
  printStyles,
];

// Exporting compiled global styles
export default $ => css(styles.map(style => style($)));
